import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { setTitleAndScrollToTop, message, setCurrentShow, setRoute } from "../actions";
import Configuration from "../config";

import { activateUser, changeUserPassword, resetUserPassword, addUserPassword, getResetMail, validateToken, checkAddUserPassword } from "../actions/Users";
import Form from "../components/Form";
import Icon from "../components/Icon";
import getFromQueryString from "../components/URLParams";
import ReactGA from "react-ga";

const mapStateToProps = ( state ) =>
{
	return {
		route: state.route,
		user: state.user,
		title: state.title,
		show: state.show
	};
};
const mapDispatchToProps = ( dispatch ) =>
{
	return {
		resetRoute: () =>
		{
			dispatch( setRoute( null ) );
		},
		activateUser: ( key ) =>
		{
			dispatch( activateUser( key ) );
		},
		addUserPassword: ( a_formData ) =>
		{
			dispatch( addUserPassword( a_formData ) );
		},
		changeUserPassword: ( a_formData, a_user_id ) =>
		{
			dispatch( changeUserPassword( a_formData, a_user_id ) );
		},
		resetUserPassword: ( a_formData ) =>
		{
			dispatch( resetUserPassword( a_formData ) );
		},
		getResetLink: ( a_formData ) =>
		{
			dispatch( getResetMail( a_formData ) );
		},
		checkAddUserPassword: ( a_token ) =>
		{
			return dispatch( checkAddUserPassword( a_token ) );
		},
		validateToken: ( a_token ) =>
		{
			dispatch( validateToken( a_token ) );
		},
		setTitleAndScrollToTop: ( title ) =>
		{
			dispatch( setCurrentShow( title ) );
			dispatch( setTitleAndScrollToTop( title ) );
		},
		setCurrentShow: ( show ) =>
		{
			dispatch( setCurrentShow( show ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Komponente um statische Inhalte auszugeben
 */
class UserActions extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = {
			key: null
		};
		
		// Show initial null setzen
		this.props.setCurrentShow( null );
		
		this.handleUserPassword = this.handleUserPassword.bind( this );
		
	} // function constructor(...)
	
	componentDidUpdate( a_prevProps )
	{
		const { pathname } = { ...this.props.location };
		
		if ( a_prevProps.route !== null && a_prevProps.route !== pathname )
		{
			this.props.history.push( a_prevProps.route );
			this.props.resetRoute();
		}
		
	} // function componentDidUpdate(...)
	
	componentDidMount()
	{
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.pageview( this.props.location.pathname );
		}
		
		const key = getFromQueryString( "key" );
		
		switch ( this.props.location.pathname )
		{
			case "/aktivierung":
				if ( key !== null && key.length > 0 )
				{
					this.props.activateUser( key );
				}
				else
				{
					this.props.history.push( "/" );
				}
				break;
			
			case "/passwort":
				if ( key !== null && key.length > 0 )
				{
					this.props.checkAddUserPassword( key ).then(
						a_result =>
						{
							if ( a_result )
							{
								this.props.setTitleAndScrollToTop( "Passwort anlegen" );
							}
							else
							{
								this.props.history.push( "/" );
							}
						}
					);
				}
				else
				{
					this.props.history.push( "/" );
				}
				break;
			
			case "/passwort-vergessen":
				this.props.setTitleAndScrollToTop( "Passwort vergessen" );
				break;
			
			case "/passwort-zuruecksetzen":
				if ( key !== null && key.length > 0 )
				{
					this.props.validateToken( key );
				}
				else
				{
					this.props.history.push( "/" );
				}
				break;
			
			case "/passwort-aendern":
				// Diese Aktion darf nur durchgeführt werden, wenn der Nutzer eingeloggt ist
				this.props.setTitleAndScrollToTop( "Passwort ändern" );
				break;
			
			default:
				this.props.history.push( "/" );
			
		}
		
	} // function componentDidMount()
	
	handleUserPassword( event, formData, action = "" )
	{
		const { user } = { ...this.props };
		
		switch ( action )
		{
			case "add":
				const activationKey = getFromQueryString( "key" );
				if ( activationKey )
				{
					this.props.addUserPassword( { ...formData, key: activationKey } );
				}
				break;
			
			case "reset":
				const resetKey = getFromQueryString( "key" );
				if ( resetKey )
				{
					this.props.resetUserPassword( { ...formData, key: resetKey } );
				}
				break;
			
			case "reset-email":
				this.props.getResetLink( formData );
				break;
			
			case "change":
				this.props.changeUserPassword( { ...formData, email: user.email }, user.id );
				break;
			
			default:
				this.props.history.push( "/" );
		}
		
		event.preventDefault();
		
	} // function handleUserPassword(...)
	
	render()
	{
		const { show } = { ...this.props };
		
		return <article>
			<section className={"white"}>
				{
					show === "Passwort anlegen" &&
					<Form
						id={`form-add-user-password`}
						submitValue={[ <Icon key={`form-add-user-password-icon`} iconName={"save"}/>,
							<span key={`form-add-user-password-text`}>Passwort anlegen</span> ]}
						className="col s12"
						onSubmit={( event, formData ) => this.handleUserPassword( event, formData, "add" )}
						fields={
							[
								{
									name: "password",
									title: "Passwort",
									type: "password",
									maxLength: "80",
									required: true,
									className: "col s12 l6",
									cleared: true,
									help: "Mindestens 7 Buchstaben und 1 Sonderzeichen (!@#$%^&\"'.,+*-)",
									validator: ( a_value ) =>
									{
										if ( !Configuration.passwordRegex.test( a_value ) )
										{
											this.props.message( "Das Passwort muss mindestens 7 Buchstaben und 1 Sonderzeichen enthalten." );
											return false;
										}
										
										return true;
									}
								},
								{
									name: "password_2",
									title: "Passwort wiederholen",
									type: "password",
									maxLength: "80",
									required: true,
									className: "col s12 l6"
								}
							]
						}
						validator={
							( a_domElements ) =>
							{
								const pw1 = a_domElements[ "password" ].value;
								const pw2 = a_domElements[ "password_2" ].value;
								if ( pw1 !== pw2 )
								{
									this.props.message( "Die Passwörter stimmen nicht überein." );
									return false;
								}
								else
								{
									return true;
								}
							}
						}
					/>
				}
				{
					show === "Passwort zurücksetzen" &&
					<Form
						id={`form-reset-user-password`}
						submitValue={[ <Icon key={`form-reset-user-password-icon`} iconName={"save"}/>,
							<span key={`form-reset-user-password-text`}>Passwort ändern</span> ]}
						className="col s12"
						onSubmit={( event, formData ) => this.handleUserPassword( event, formData, "reset" )}
						fields={
							[
								{
									name: "password",
									title: "Passwort",
									type: "password",
									maxLength: "80",
									required: true,
									className: "col s12 l6",
									cleared: true,
									help: "Mindestens 7 Buchstaben und 1 Sonderzeichen (!@#$%^&\"'.,+*-)",
									validator: ( a_value ) =>
									{
										if ( !Configuration.passwordRegex.test( a_value ) )
										{
											this.props.message( "Das Passwort muss mindestens 7 Buchstaben und 1 Sonderzeichen enthalten." );
											return false;
										}
										
										return true;
									}
								},
								{
									name: "password_2",
									title: "Passwort wiederholen",
									type: "password",
									maxLength: "80",
									required: true,
									className: "col s12 l6",
									cleared: true
								}
							]
						}
						validator={
							( a_domElements ) =>
							{
								const pw1 = a_domElements[ "password" ].value;
								const pw2 = a_domElements[ "password_2" ].value;
								if ( pw1 !== pw2 )
								{
									this.props.message( "Die Passwörter stimmen nicht überein." );
									return false;
								}
								else
								{
									return true;
								}
							}
						}
					/>
				}
				{
					show === "Passwort vergessen" &&
					<Form
						id={`form-password-forgotten`}
						submitValue={[ <Icon key={`form-password-forgotten-icon`} iconName={"save"}/>,
							<span key={`form-password-forgotten-text`}>Passwort zurücksetzen</span> ]}
						className="col s12"
						onSubmit={( event, formData ) => this.handleUserPassword( event, formData, "reset-email" )}
						fields={
							[
								{
									name: "email",
									title: "E-Mail-Adresse",
									type: "email",
									required: true,
									className: "col s12 l6",
									maxLength: "80"
								}
							]
						}
						errorMessage={( a_message, a_type, a_timeout ) => this.props.message( a_message, a_type, a_timeout )}
					/>
				}
				{
					show === "Passwort ändern" &&
					<Form
						id={`form-change-user-password`}
						submitValue={[ <Icon key={`form-change-user-password-icon`} iconName={"save"}/>,
							<span key={`form-change-user-password-text`}>Passwort ändern</span> ]}
						className="col s12"
						onSubmit={( event, formData ) => this.handleUserPassword( event, formData, "change" )}
						fields={
							[
								{
									name: "old_password",
									title: "Altes Passwort",
									type: "password",
									maxLength: "80",
									required: true,
									className: "col s12 l6",
									cleared: true
								},
								{
									name: "password",
									title: "Passwort",
									type: "password",
									maxLength: "80",
									required: true,
									className: "col s12 l6",
									cleared: true,
									help: "Mindestens 7 Buchstaben und 1 Sonderzeichen (!@#$%^&\"'.,+*-)",
									validator: ( a_value ) =>
									{
										if ( !Configuration.passwordRegex.test( a_value ) )
										{
											this.props.message( "Das Passwort muss mindestens 7 Buchstaben und 1 Sonderzeichen enthalten." );
											return false;
										}
										
										return true;
									}
								},
								{
									name: "password_2",
									title: "Passwort wiederholen",
									type: "password",
									maxLength: "80",
									required: true,
									className: "col s12 l6"
								}
							]
						}
						errorMessage={( a_message, a_type, a_timeout ) => this.props.message( a_message, a_type, a_timeout )}
						validator={
							( a_domElements ) =>
							{
								const pw1 = a_domElements[ "password" ].value;
								const pw2 = a_domElements[ "password_2" ].value;
								if ( pw1 !== pw2 )
								{
									this.props.message( "Die Passwörter stimmen nicht überein." );
									return false;
								}
								else
								{
									return true;
								}
							}
						}
					/>
				}
			</section>
		</article>;
		
	} // function render()
	
} // class

UserActions = connect(
	mapStateToProps,
	mapDispatchToProps
)( UserActions );

export default withRouter( UserActions );
